<template>
  <div class="campsite">
    <div
      class="campsite__inner white-box"
      :class="[
        { active: isActive },
        campsite.amount > 0 ? 'clickable' : 'campsite__inner--disabled',
      ]"
      @click="campsite.amount > 0 && $emit('select-campsite', campsite)"
    >
      <div class="row">
        <div class="col-12 col-md-4">
          <div
            class="position-relative image-slider__slider"
            @click.stop.prevent="campsite.images.length && openImageModal()"
          >
            <template v-if="campsite.images.length && campsite.images.length > 1">
              <ci-slider :options="sliderConfig" @moved="onSliderMoved" @init="onSliderInit">
                <div class="glide__track h-100" data-glide-el="track">
                  <ul class="glide__slides h-100 m-0 p-0">
                    <li
                      v-for="(image, idx) in campsite.images"
                      :key="idx"
                      class="glide__slide position-relative h-100"
                    >
                      <img
                        :key="idx"
                        :draggable="false"
                        :alt="image.title"
                        :src="image.variants['4_3'].url"
                        class="img-fluid"
                      />
                    </li>
                  </ul>
                </div>
              </ci-slider>

              <div class="glide__arrows" data-glide-el="controls">
                <div
                  v-if="campsite.images.length > 1"
                  data-glide-dir="<"
                  class="
                    image-slider__image-navigation image-slider__image-navigation--prev
                    d-flex
                    align-items-center
                    position-absolute
                    h-100
                    px-2
                  "
                  @click.prevent.stop="onPreviousImage"
                >
                  <iconArrowWhite class="icon icon--arrow"></iconArrowWhite>
                </div>
                <div
                  v-if="campsite.images.length > 1"
                  data-glide-dir=">"
                  class="
                    image-slider__image-navigation image-slider__image-navigation--next
                    d-flex
                    align-items-center
                    position-absolute
                    h-100
                    px-2
                  "
                  @click.prevent.stop="onNextImage"
                >
                  <iconArrowWhite class="icon icon--arrow"></iconArrowWhite>
                </div>
              </div>
              <div
                v-if="campsite.images.length > 1"
                class="image-slider__image-gradient position-absolute"
              >
                <div
                  class="
                    image-slider__image-pagination
                    d-flex
                    justify-content-center
                    align-items-center
                    position-absolute
                  "
                >
                  <span
                    v-for="(img, idx) in campsite.images"
                    :key="idx"
                    class="image-slider__image-pagination-dot"
                    :class="{
                      'image-slider__image-pagination-dot--active': activeImage - 1 === idx,
                    }"
                    >{{ idx + 1 }}</span
                  >
                </div>
              </div>
            </template>
            <!-- only one image -->
            <img
              v-if="campsite.images.length === 1"
              :alt="campsite.images[0].title"
              :src="campsite.images[0].variants['4_3'].url"
              class="image-slider__image-single"
            />

            <!-- fallback image -->
            <div v-if="!campsite.images.length" class="image-slider__image--fallback">
              <iconFallbackImage class="icon"></iconFallbackImage>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-8 py-0 py-md-3">
          <div class="row h-100 align-items-center pr-0 pr-md-3">
            <span class="live_info" v-if="campground.pms_live_api_active">
              <svg
                style="width: 1rem"
                data-v-d9a8636a=""
                viewBox="0 0 21 21"
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
              >
                <g data-v-d9a8636a="" fill="#000" fill-rule="nonzero">
                  <path
                    data-v-d9a8636a=""
                    d="M10.533 20.694a10.165 10.165 0 1110.161-10.16c-.008 5.608-4.552 10.152-10.16 10.16zm0-18.852a8.691 8.691 0 108.688 8.691 8.698 8.698 0 00-8.688-8.69z"
                  ></path>
                  <circle data-v-d9a8636a="" cx="10.533" cy="7.07" r="1.179"></circle>
                  <path data-v-d9a8636a="" d="M9.616 9.155h1.813v6.016H9.616z"></path>
                </g>
              </svg>
              If you click on this item, the real price and availabilty will be fetched from the PMS
              of the Campsite, please wait for it.
            </span>

            <span v-if="campsite.amount > 0 && false" class="campsite__availability">
              {{ $t('pages.checkoutStepTwo.campsiteAmountText', { amount: campsite.amount }) }}
            </span>
            <div
              class="col-12 col-md-6 order-1 order-md-2"
              :class="{ 'col-md-8': campsite.amount <= 0 }"
            >
              <div class="campsite__meta">
                <h3 class="meta__headline">
                  {{ campsite.name }}

                  <button
                    v-if="attributes && attributes.length > 0"
                    class="info-icon"
                    @click.prevent.stop="showAttributes(campsite.name)"
                  >
                    <iconInfoBlack />
                  </button>
                </h3>
                <div class="meta__description" v-html="campsite.description"></div>
                <ul
                  v-if="
                    campsite.top1_attribute || campsite.top2_attribute || campsite.top3_attribute
                  "
                  class="topx__section attribute-list"
                >
                  <li
                    v-for="field in ['top1_attribute', 'top2_attribute', 'top3_attribute']"
                    v-if="campsite[field]"
                    :key="field"
                  >
                    <span v-html="campsite[field].icon_svg"></span>
                    <span>{{ campsite[field].name }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="campsite.amount > 0" class="col-6 col-md-4 order-2 order-md-2">
              <div class="campsite__price">
                <span class="price__value">{{
                  campsite.prices.total | currency(campground.currency, language.code)
                }}</span>
                <span class="price__value price__value--alt" v-if="campsite.prices.total_alt">{{
                  campsite.prices.total_alt | currency(currency.code, language.code)
                }}</span>
                <span class="price__meta">{{
                  $tc('pages.checkoutStepTwo.priceInfo', nights > 1 ? 0 : 1, { nights })
                }}</span>
              </div>
            </div>
            <div
              class="col-6 col-md-2 order-3 order-md-3 d-flex align-items-center"
              :class="{ 'offset-6 offset-md-0 col-md-4': campsite.amount <= 0 }"
            >
              <div class="campsite__status">
                <div
                  class="status__circle"
                  v-if="campsite.amount > 0"
                  :class="{ 'status__circle--active': isActive }"
                >
                  <iconCheckmarkWhite class="icon"></iconCheckmarkWhite>
                </div>
                <span
                  class="warning"
                  v-if="campsite.amount <= 0"
                  :class="{ 'status__circle--active': isActive }"
                >
                  {{ $t(`pages.checkoutStepTwo.campsiteNotAvailableLabel`) }}
                  <iconLock class="icon"></iconLock>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="campsite.amount <= 0">
        <div class="col-12">
          <div class="campsite__reason">
            <div class="has-icon">
              <iconWarning class="icon"></iconWarning>
            </div>
            <div class="reason-title">
              {{ $t(`pages.checkoutStepTwo.campsiteNotAvailableTitle`) }}
            </div>
            <div
              class="reason-content"
              v-if="campsite.reason_txt"
              v-html="campsite.reason_txt"
            ></div>
            <div class="reason-content" v-if="campsite.reason && !campsite.reason_txt">
              {{ $t(`pages.checkoutStepTwo.campsiteNotAvailableReasons.${campsite.reason}`) }}
              <span
                v-if="
                  campsite.reason === 'invalidArrivalAndDepartureWeekday' ||
                    campsite.reason === 'invalidArrivalWeekday' ||
                    campsite.reason === 'invalidDepartureWeekday'
                "
              >
                <span class="restricted-weekdays">
                  <span
                    v-if="
                      campsite.reason === 'invalidArrivalAndDepartureWeekday' ||
                        campsite.reason === 'invalidArrivalWeekday'
                    "
                    v-html="
                      $t('pages.checkoutStepTwo.restrictedArrivalWeekdays', {
                        days: getWeekdaysString(campsite.arrival_weekdays),
                      }) + ' '
                    "
                  ></span>
                  <span
                    v-if="
                      campsite.reason === 'invalidArrivalAndDepartureWeekday' ||
                        campsite.reason === 'invalidDepartureWeekday'
                    "
                    v-html="
                      $t('pages.checkoutStepTwo.restrictedDeparturelWeekdays', {
                        days: getWeekdaysString(campsite.departure_weekdays),
                      }) + ' '
                    "
                  ></span>
                  <a
                    class="action"
                    href="#"
                    @click="
                      $emit('to-step', { number: 1, key: 'displaySelection', value: 'dates' })
                    "
                    >{{ $t('pages.checkoutStepTwo.changeTravelDates') }}</a
                  >
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CiProgressNavigation
      class="campground__navigation--inline"
      v-if="isActive"
      :active-step="activeStep"
      :status="status"
      :steps="steps"
    >
    </CiProgressNavigation>

    <modal :name="campsite.name" height="auto" adaptive scrollable>
      <div class="attribute-modal">
        <button class="attribute-modal__close" @click="$modal.hide(campsite.name)">
          <icon-close-dark />
        </button>

        <h3 class="meta__headline">
          {{ campsite.name }}
        </h3>

        <div class="row">
          <template v-for="category in attributes">
            <div class="col-12 col-md-6" :key="category.name">
              <h4>{{ category.name }}</h4>
              <ul class="attribute-list">
                <li
                  v-for="attribute in category.attributes"
                  :key="attribute.id"
                  class="attribute-item"
                >
                  <icon-checkmark-white
                    v-if="attribute.positive_flag"
                    class="attribute-checkmark"
                  />
                  <icon-cross-white v-else class="attribute-cross" />
                  {{ attribute.name }}
                </li>
              </ul>
            </div>
          </template>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { CiProgressNavigation, CiSlider, CiImageModal } from '@/components'

import iconCheckmarkWhite from '@/assets/icons/checkmark-white.svg'
import iconCrossWhite from '@/assets/icons/cross-white.svg'
import iconLock from '@/assets/icons/lock-solid.svg'
import iconWarning from '@/assets/icons/warning-orange.svg'
import iconArrowWhite from '@/assets/icons/arrow-white-dynamic.svg'
import iconInfoBlack from '@/assets/icons/info-black.svg'
import iconFallbackImage from '@/assets/icons/image-line.svg'
import iconCloseDark from '@/assets/icons/close-dark.svg'

export default {
  name: 'CiAccommodation',

  components: {
    CiImageModal,
    CiProgressNavigation,
    CiSlider,
    iconArrowWhite,
    iconCheckmarkWhite,
    iconCrossWhite,
    iconInfoBlack,
    iconFallbackImage,
    iconLock,
    iconWarning,
    iconCloseDark,
  },

  props: {
    activeStep: {
      type: Number,
      required: true,
    },

    campground: {
      type: Object,
      required: true,
    },

    campsite: {
      type: Object,
      required: true,
    },

    isActive: {
      type: Boolean,
      default: false,
    },

    steps: {
      type: Object,
      required: true,
    },

    status: {
      type: Object,
      required: true,
    },

    language: {
      type: Object,
      required: true,
    },

    currency: {
      type: Object,
      required: true,
    },

    nights: {
      type: Number,
      required: true,
    },

    attributes: {
      type: Array,
      required: false,
    },
  },

  data() {
    return {
      activeImage: 1,
      slider: null,
      sliderConfig: {
        gap: 0,
        perView: 1,
        startAt: 0,
        type: 'carousel',
      },
    }
  },

  methods: {
    showAttributes(modalName) {
      this.$modal.show(modalName)
    },
    getWeekdaysString(days) {
      let names = []
      let idx = 0
      let hasSunday = false
      for (let day = 4; day <= 10; day++) {
        if (days.indexOf(idx) !== -1) {
          if (idx === 0) {
            hasSunday = true
          } else {
            names.push(
              new Date(1970, 0, day).toLocaleString(this.language.code, { weekday: 'long' })
            )
          }
        }
        idx++
      }
      if (hasSunday) {
        names.push(new Date(1970, 0, 4).toLocaleString(this.language.code, { weekday: 'long' }))
      }
      return names.join(', ')
    },

    onSliderInit(slider) {
      this.slider = slider
    },

    onSliderMoved(slider) {
      this.activeImage = slider.index + 1
    },

    onPreviousImage() {
      this.slider.go('<')
    },

    onNextImage() {
      this.slider.go('>')
    },

    openImageModal() {
      const settings = {
        adaptive: true,
        clickToClose: true,
        height: 'auto',
        maxWidth: 800,
        pivotY: 0.5,
        scrollable: true,
        width: '100%',
      }

      this.$modal.show(
        CiImageModal,
        {
          title: this.campsite.name,
          images: this.campsite.images,
        },
        settings,
        {}
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.campsite {
  margin: 0 0 20px;
}

.campsite__inner {
  margin: 0;
  padding: 0;
  position: relative;
  transition: border 0.4s ease;

  &.campsite__inner--disabled {
    color: $light-gray-text;
    background-image: repeating-linear-gradient(
      45deg,
      #f6f6f6,
      #f6f6f6 5px,
      #fcfcfc 5px,
      #fcfcfc 20px
    );
    border: 1px solid rgba(155, 155, 155, 0.5);
    padding-bottom: 0;

    .no-touch &:hover {
      border: 1px solid rgba(155, 155, 155, 0.5);
    }
  }

  &.active,
  .no-touch &:hover {
    border-color: var(--primary-color);
  }
}

.campsite__reason {
  @include clearfix;
  @include font-format(0.75rem, 1.25rem);

  color: black;
  background-color: #fefcdd;
  padding: 12px 15px;
  margin: 0;

  .icon {
    width: 20px;
    height: auto;
  }

  & > div {
    float: left;
  }

  .has-icon {
    width: 40px;
  }
  .reason-title {
    @include font('gotham_mediumregular');

    width: 150px;
  }
  .reason-content {
    width: 100%;
    margin-top: 10px;
    @include media-breakpoint-up(sm) {
      width: calc(100% - 190px);
      margin-top: 0;
    }

    .action {
      color: var(--primary-color);
      text-decoration: underline;
      font-weight: bold;

      &:hover {
        text-decoration: none;
      }
    }
  }
}

.campsite__status {
  align-items: center;
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: flex-end;
  padding: 20px 20px 20px 0;

  @include media-breakpoint-up(md) {
    height: auto;
    justify-content: center;
    padding: 0;
  }

  .status__circle {
    align-items: center;
    background: #cdcccd;
    border-radius: 50%;
    display: flex;
    height: 30px;
    justify-content: center;
    opacity: 0.5;
    width: 30px;
    transition: background-color 0.6s ease;
    align-self: flex-end;

    .icon {
      width: 17px;
      height: auto;
    }

    &.status__circle--active {
      opacity: 1;
      background: var(--primary-color);
    }

    @include media-breakpoint-up(md) {
      height: 45px;
      width: 45px;

      .icon {
        width: 27px;
        height: auto;
      }
    }
  }

  .warning {
    @include font('gotham_mediumregular');
    @include font-format(0.625rem, 1rem);

    position: relative;
    background-color: #fefcda;
    border-radius: 8px;
    color: #f5a623;
    padding: 8px 32px 6px 12px;
    text-transform: uppercase;

    .icon {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(-10px, -50%);
      width: 11px;
      height: auto;
      fill: #f5a623;
    }
  }
}

.campsite__meta {
  border-bottom: 1px solid hsla(0, 0%, 60.8%, 0.5);
  flex: 3;
  padding: 20px;

  @include media-breakpoint-up(md) {
    border: 0;
    padding: 0;
  }

  .meta__headline {
    @include font-format(1rem, 1.625em);

    margin-bottom: 15px;
  }

  .meta__description {
    @include font-format(1rem, 1.25rem);

    margin: 0;
    padding: 0;
  }
}

.campsite__price {
  @include font('gotham_mediumregular');
  @include font-format(1.375rem, 1.625em);

  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 0 10px 20px;

  @include media-breakpoint-up(md) {
    padding: 0 20px 0 0;
    align-items: center;
  }

  .price__value--alt {
    @include font-format(1rem, 1.25em);

    color: $light-gray-text;
    margin: 0 0 5px 0;
  }

  .price__meta {
    @include font('gotham_mediumregular');
    @include font-format(0.625rem, 1.625em);

    color: $light-gray-text;
    margin: 0 10px 0 0;
  }
}

.campsite__availability {
  position: absolute;
  bottom: 0.25rem;
  right: 1.5rem;
  font-size: 12px;
  color: $light-gray-text;
}

.live_info {
  @include font('gotham_mediumregular');
  @include font-format(0.85rem, 1.625em);

  color: $gray-text;
  margin: 0 10px 5px 0;
  // margin: auto;
  align-content: center;
}

.attribute-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.attribute-list li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.1rem;
}

.attribute-list li span:first-child {
  display: inline-flex;
  width: 1.5rem;
  height: 1.5rem;
}
.topx__section {
  margin-top: 1rem;
}
</style>
